import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from 'react';
import Marquee from "react-fast-marquee";

const LogoMarquee = (props) => {
    const sc = props.slice.primary;

    const logo = props.slice.items;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg =
    sc.background === "gradient"
      ? "gradient-to-b from-grey-light to-white"
      : sc.background === "grey"
      ? "grey-light"
      : sc.background === "dark grey"
      ? "grey-d"
      : sc.background;

    return (
        <section className={"relative bg-" + bg + " " + space}>
            <div className="wrapper">
                <Marquee gradient={true} autoFill={true}>
                    {logo.map((image, index) => {
                        return (
                            <div key={index} className="mx-6"><GatsbyImage className="w-32" image={getImage(image.logo)} alt={image.alt}></GatsbyImage></div>
                        )
                    })}
                </Marquee>
            </div>
        </section>
    );
}

export default LogoMarquee;
